import { useFormContext } from 'react-hook-form';

import { FormFieldRenderer } from '../components';
import { administrativeFields } from '../data';
import { IArrestFormData } from '../types';

interface AdministrativeInfoTabProps {
  viewMode?: boolean;
}

const AdministrativeInfoTab = ({
  viewMode = false,
}: AdministrativeInfoTabProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IArrestFormData>();

  return (
    <div className="space-y-6 w-full">
      <div className="grid grid-cols-12 gap-4">
        {administrativeFields.map((field) => (
          <FormFieldRenderer
            key={field.name}
            field={field}
            control={control}
            errors={errors}
            viewMode={viewMode}
          />
        ))}
      </div>
    </div>
  );
};

export default AdministrativeInfoTab;
